// Translate a 0-based index into a spreadsheet-style letter (A, B, …, Z, AA,
// AB, …). Caps out around 26 for normal MC slides; the recursion is just
// defensive for any future bulk-option scenarios.
export const letterFor = (i: number): string => {
  if (i < 0) return '';
  const a = 'A'.charCodeAt(0);
  if (i < 26) return String.fromCharCode(a + i);
  return letterFor(Math.floor(i / 26) - 1) + letterFor(i % 26);
};
